import { render } from "./letter-import.vue?vue&type=template&id=3878b4ad"
import script from "./letter-import.vue?vue&type=script&lang=js"
export * from "./letter-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__